// ============================================================================
// Recommendations — panels in the chat (the composer transform)
// ============================================================================
// There is ONE chat. The recommendation row renders inside the chat widget,
// and activating a recommendation transforms the composer into a panel for
// it — still the chat: type, attach, and drag keep working; esc collapses;
// Send assembles the panel's structured values + the composer's note and
// attachments into one human message tagged `recommendation_id`.
//
//   <Chat.Root streamOptions={...} useComposer={useAppComposer}>
//     <Chat.Recommendations.Root renderers={APP_PANELS}>
//       <Chat.Messages.List>
//         {messages.map(m => m.type === "human"
//           ? <Chat.Recommendations.SubmissionMessage key={m.id} message={m}
//               fallback={<Chat.UserMessage message={m} />} />
//           : ...)}
//       </Chat.Messages.List>
//       <Chat.Recommendations.Chips label="Suggested next steps" />
//       <Chat.Recommendations.Composer>
//         {/* the surface's normal input */}
//       </Chat.Recommendations.Composer>
//     </Chat.Recommendations.Root>
//   </Chat.Root>
//
// The app injects ONLY the renderer mapping (component name → panel /
// transcript view / chrome); generic `collects` fields render without any
// app code. See plans/recommendations.md (launch10) for the full contract.

export {
  RecommendationsRoot,
  useRecommendations,
  useRecommendationPanel,
  useRecommendationRenderers,
  type RecommendationsRootProps,
  type RecommendationsContextValue,
} from "./RecommendationsContext";

export {
  RecommendationChips,
  type RecommendationChipsProps,
} from "./RecommendationChips";

export {
  RecommendationComposer,
  GenericFieldsPanel,
  type RecommendationComposerProps,
} from "./RecommendationPanel";

export {
  RecommendationSubmissionMessage,
  getRecommendationSubmission,
  type RecommendationSubmissionMessageProps,
  type RecommendationSubmissionInfo,
} from "./SubmissionMessage";

export {
  buildRecommendationSubmission,
  attachmentTag,
  attachmentTagPrefix,
  type RecommendationSubmissionInput,
  type RecommendationSubmissionMessage as RecommendationSubmissionPayload,
} from "./buildSubmission";

export { parseRecommendationFields } from "./parseCollects";

export type {
  Recommendation,
  RecommendationFieldSpec,
  RecommendationCollects,
  CollectedValue,
  CollectedValues,
  ParsedRecommendationField,
  RecommendationPanelProps,
  RecommendationSubmissionProps,
  RecommendationPanelDescriptor,
  RecommendationPanelRenderers,
} from "./types";

import { RecommendationsRoot } from "./RecommendationsContext";
import { RecommendationChips } from "./RecommendationChips";
import { RecommendationComposer } from "./RecommendationPanel";
import { RecommendationSubmissionMessage } from "./SubmissionMessage";

/** Compound component — `Chat.Recommendations.{Root,Chips,Composer,SubmissionMessage}`. */
export const Recommendations = {
  Root: RecommendationsRoot,
  Chips: RecommendationChips,
  Composer: RecommendationComposer,
  SubmissionMessage: RecommendationSubmissionMessage,
};
